module.exports = __webpack_public_path__ + "assets/img/image_trade_anywhere_devices-768x512.7bafe300.png";